import React from "react";
import { Field } from "react-final-form";
import { Input } from "components/ui/input";
import AccountValidationMessage from "./AccountValidationMessage";

const EmailField: React.FC = () => (
    <div className="flex flex-col gap-1.5">
        <label
            htmlFor="login-username"
            className="ml-1 font-nunito text-xs font-black uppercase leading-4 tracking-wide text-gray-900"
        >
            Adresse email
        </label>
        <Field name="username">
            {({ input, meta }) => (
                <>
                    <Input
                        {...input}
                        id="login-username"
                        type="email"
                        placeholder="votre@email.com"
                        autoComplete="email"
                        required
                        className="h-16 rounded-3xl border-0 bg-slate-50 px-8 font-nunito text-base font-bold text-gray-900 outline outline-1 outline-slate-100 placeholder:text-gray-900/50 focus-visible:outline-2 focus-visible:outline-indigo-600 focus-visible:ring-0 focus-visible:ring-offset-0"
                    />
                    {meta.submitError && (
                        <div aria-live="polite" className="ml-1 text-xs text-red-500">{meta.submitError}</div>
                    )}
                </>
            )}
        </Field>
        <div className="text-center text-sm text-red-500">
            <AccountValidationMessage />
        </div>
    </div>
);

export default EmailField;
